import { gql } from '@apollo/client';

export type GetWorkspaceDatasetsType = {
  datasets: {
    id: string;
    description: string;
    lastSubmitted: string;
    type: string;
    status: string;
    csvFile?: {
      id: string;
      name: string;
    };
  }[];
};

export const GET_WORKSPACE_DATASETS = gql`
  query GetWorkspaceDatasets($workspaceId: ID!) {
    datasets: getWorkspaceDatasets(workspaceId: $workspaceId) {
      id
      description
      lastSubmitted
      type
      status
      csvFile {
        id
        name
      }
    }
  }
`;
